import { useCallback } from 'react';

import { activityFeedKey } from '@splitfiesta/core';

import { useFeatureFlagsQuery } from '@/hooks/queries/useFeatureFlagsQuery';

/**
 * The feed waits for the flags so a cold start does not fetch once without
 * events and again with them. An errored flags query keeps its last answer,
 * which the persisted cache holds across restarts; with none it counts as off.
 */
export function useActivityFeedKeyParts(groupId?: string) {
  const { data, isSuccess, isError } = useFeatureFlagsQuery();
  const includeEvents = data?.pro === true;
  const flagsReady = isSuccess || isError;

  const keyFor = useCallback(
    (params?: Record<string, unknown>) =>
      activityFeedKey({ groupId, params, includeEvents }),
    [groupId, includeEvents]
  );

  return { includeEvents, flagsReady, keyFor };
}
